var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIconModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 12.2444,
    cy: 12.0001,
    rx: 12.2444,
    ry: 12.0001,
    transform: "matrix(0.999771 -0.0214075 0.0222884 0.999752 0.695312 0.525391)",
    fill: "#D4BBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9345 14.3005C17.7961 14.4613 17.5988 14.5591 17.3873 14.5718C17.1758 14.5845 16.968 14.511 16.8112 14.368L13.192 11.1554L9.71859 14.4837C9.4058 14.8065 8.89232 14.8175 8.56545 14.5084C8.26509 14.1866 8.27303 13.6842 8.5834 13.3728L12.578 9.49102C12.726 9.34784 12.9225 9.26614 13.1281 9.26231C13.3316 9.25777 13.5292 9.3311 13.6807 9.46741L17.8662 13.174C18.0301 13.3204 18.1283 13.5268 18.1385 13.7466C18.1433 13.9506 18.0703 14.1487 17.9345 14.3005Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconModal);
export default __webpack_public_path__ + "static/media/closeIconModal.3979e66435a73e290b3d9252732c4f0b.svg";
export { ForwardRef as ReactComponent };